;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="c9717432-ccac-4024-9972-65bce7e7d5f6",e._sentryDebugIdIdentifier="sentry-dbid-c9717432-ccac-4024-9972-65bce7e7d5f6")}catch(e){}}();import React__default from 'react';
import { ErrorBoundary } from '../node_modules/.pnpm/react-error-boundary@3.1.4_react@18.3.1/node_modules/react-error-boundary/dist/react-error-boundary.esm.js';
import { withSentryHub } from './sentry.js';
import '../_virtual/_sentry-release-injection-file.js';

const SentryBoundary = ({ children }) => {
    const ErrorBoundaryHandler = (error) => withSentryHub()?.captureException(error);
    return (React__default.createElement(ErrorBoundary, { fallbackRender: () => React__default.createElement("div", null), onError: ErrorBoundaryHandler }, children));
};

export { SentryBoundary };
//# sourceMappingURL=SentryBoundary.js.map
